"use client";

import { c as _c } from "react/compiler-runtime";
import { useAIChatContext } from "./contexts";
interface AIChatStreamingIndicatorProps {
  className?: string;
}
export function AIChatStreamingIndicator(t0) {
  const $ = _c(6);
  const {
    className
  } = t0;
  const {
    state
  } = useAIChatContext();
  if (!state.isStreaming || !state.streamingText) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="ml-0.5 inline-block h-3 w-0.5 animate-pulse bg-primary" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== state.streamingText) {
    t2 = <p className="text-body leading-relaxed text-foreground">{state.streamingText}{t1}</p>;
    $[1] = state.streamingText;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== className || $[4] !== t2) {
    t3 = <div className={className}>{t2}</div>;
    $[3] = className;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}